import { fetchWithRedirect } from "./base";
import { SettingsURL } from "../settings";

// AUTH
export async function signIn(email, password, enableTwoAuth = true) {
  const url =
    SettingsURL + "/auth/login/" + (enableTwoAuth ? "" : "extension/");

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    },
    body: JSON.stringify(
      `grant_type=&username=${email}&password=${password}&scope=&client_id=&client_secret=`,
    ),
  };

  return await fetchWithRedirect(url, options, true);
}

export async function sendEmailNewPassword(email) {
  const url = `${SettingsURL}/user/forget-password/?email=${email}`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await fetchWithRedirect(url, options);
}

export async function SignUp(data_in) {
  const url = SettingsURL + "/auth/signup/";
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data_in),
  };

  return await fetchWithRedirect(url, options);
}

export async function getMyData(token) {
  const url = SettingsURL + "/auth/me/";
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return await fetchWithRedirect(url, options);
}

export async function validate2Fa(email, password, code) {
  const url = SettingsURL + "/auth/2fa/";
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password, code }),
  };

  return await fetchWithRedirect(url, options, true);
}

export async function validateMagicToken(token) {
  const url = SettingsURL + "/magic-token/?token_id=" + token;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await fetchWithRedirect(url, options, true);
}
